module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social-combo"
  }, [_vm._m(0), _vm._v(" "), _c('social-sharing', {
    attrs: {
      "url": _vm.url
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "social-sharing floating-box"
          }, [_c('span', {
            staticClass: "cta"
          }, [_vm._v("Share this")]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-fw fa-facebook",
            attrs: {
              "aria-hidden": "true"
            }
          }), _vm._v(" "), _c('span', [_vm._v("Facebook")])]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-fw fa-twitter",
            attrs: {
              "aria-hidden": "true"
            }
          }), _vm._v(" "), _c('span', [_vm._v("Twitter")])]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "reddit"
            }
          }, [_c('i', {
            staticClass: "fa fa-fw fa-reddit",
            attrs: {
              "aria-hidden": "true"
            }
          }), _vm._v(" "), _c('span', [_vm._v("Reddit")])]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "whatsapp"
            }
          }, [_c('i', {
            staticClass: "fa fa-fw fa-whatsapp",
            attrs: {
              "aria-hidden": "true"
            }
          }), _vm._v(" "), _c('span', [_vm._v("Whatsapp")])])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "follow-us floating-box"
  }, [_c('span', [_vm._v("Follow Us")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": "https://www.facebook.com/welcometopalestinecom/",
      "data-layout": "button_count",
      "data-action": "like",
      "data-size": "large",
      "data-show-faces": "true",
      "data-share": "false"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "twitter-follow-button",
    attrs: {
      "href": "https://twitter.com/wtpalestine",
      "data-size": "large"
    }
  }, [_vm._v("\n                Follow @wtpalestine")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37b14e54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/social.vue
// module id = 171
// module chunks = 4